import { z } from 'zod';

export const uuid = z.string().uuid();
export const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Expected YYYY-MM-DD');
export const isoDateTime = z.string().datetime({ offset: true });

/** TipTap/ProseMirror JSON document. Content is sanitised server-side against an allow-list. */
export const richText = z
  .object({ type: z.literal('doc'), content: z.array(z.any()).optional() })
  .passthrough();
export type RichText = z.infer<typeof richText>;

export const paginationQuery = z.object({
  limit: z.coerce.number().int().min(1).max(200).default(50),
  cursor: z.string().optional(),
});
export type PaginationQuery = z.infer<typeof paginationQuery>;

export interface Page<T> {
  data: T[];
  nextCursor: string | null;
}

/** RFC 7807 problem details returned for every API error. */
export interface ProblemDetails {
  type: string;
  title: string;
  status: number;
  detail?: string;
  errors?: { path: string; message: string }[];
  [k: string]: unknown;
}
